import React from "react";
import './style.css';
import imageUrl from "../../imageUrl";
import siteUrl from "../../siteUrl";
import baseUrl from "../../baseUrl";

const CardHomeDetail = (props) => {
    const {data} = props;   
    return (
        <>
        <div className={`card-home-detail`} >
            <img src={`${imageUrl}${data.image[0]}`} alt={data.name} />
            <div className="card-detail">
                <div className="home-name">{data.name}</div>
                <div className="home-price">{data.price}</div>
                <div className="home-headline">{data.headline}</div>
            </div>
        </div>
        <div className={`card-home-detail-content`} >
            <a href={siteUrl} className="back-button"> {`< กลับหน้าหลัก`}</a>
            <div className="card-detail">
                <div className="home-name">{data.name}</div>
                <div className="home-price">{data.price}</div>
                <div className="home-headline">{data.headline}</div>
            </div>
            <div className="card-content">{data.detail_th}</div>

            <a href={`${baseUrl}${data.mainWebUrl}`} className="view-button" target="_blank"> {`ดูรายละเอียดเพิ่มเติม`}</a>
        </div>
        </>
    );
}
export default CardHomeDetail;